/*
// import { gsap } from 'gsap';

window.boldLoaderNewInit = function boldLoaderNewInit() {
  if (document.querySelector('.bold-loader-new')) {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    setTimeout(function () {
      scrollLock.disablePageScroll();
    }, 100);

    const headerEl = document.querySelector('.header');
    const boldLoaderEl = document.querySelector('.bold-loader-new');
    const loaderProgress = boldLoaderEl.querySelector(
      '.bold-loader-new__progress-wr'
    );
    const loaderProgressBg = loaderProgress.querySelector(
      '.bold-loader-new__progress-bg'
    );
    const loaderProgressTextsArr = loaderProgress.querySelectorAll(
      '.bold-loader-new__progress-text'
    );
    const loaderContentEl = boldLoaderEl.querySelector(
      '.bold-loader-new__content'
    );
    const loaderWordsArr = loaderContentEl.querySelectorAll(
      '.bold-loader-new__word'
    );
    const cube = document.querySelector('.page-container');
    const cubeWr = document.querySelector('.page-container-wr');

    const homeFirsSecTitle = document.querySelector(
      '.home-first-sec .first-sec__title'
    );
    const homeFirsSecButtons = document.querySelector(
      '.home-first-sec .first-sec__buttons'
    );

    loaderProgress.style.opacity = '1';

    const duration = 1400;
    const steps = 100;
    const stepDuration = duration / steps;
    let progress = 0;

    if (headerEl) {
      headerEl.classList.add('bold-loader-new-animation');
    }

    function wordsStartAnimation() {
      const wordsCount = loaderWordsArr.length;
      if (wordsCount === 0) return;

      loaderWordsArr.forEach((word) => word.classList.remove('is-animated'));

      loaderWordsArr.forEach((word, index) => {
        const delay = (duration / wordsCount) * index;
        setTimeout(() => {
          loaderWordsArr.forEach((w) => w.classList.remove('is-animated'));
          word.classList.add('is-animated');
        }, delay);
      });
    }

    const updateProgress = () => {
      progress++;

      loaderProgressBg.style.setProperty('--progress-h', `${progress}%`);
      loaderProgressBg.style.setProperty(
        '--progress-h-reverse',
        `${100 - progress}%`
      );
      for (let i = 0; i < loaderProgressTextsArr.length; i++) {
        loaderProgressTextsArr[i].textContent = `${progress}%`;
      }

      if (progress < 100) {
        setTimeout(updateProgress, stepDuration);
      } else {
        boldLoaderEl.classList.add('is-end-animated');

        if (window.innerWidth > 1024) {
          gsap.to(cube, {
            rotationY: 0,
            duration: 1,
            ease: 'power2.inOut',
            onStart: () => {
              setTimeout(() => {
                cubeWr.classList.add('is-start-loader-animation');
              }, 380);
              /!*setTimeout(() => {
                boldLoaderEl.classList.add(
                  'is-end-first-main-before-animation'
                );
              }, 900);*!/
            },
            onComplete: () => {
              normalPageInit();
              scrollLock.enablePageScroll();
            },
          });
        } else {
          cubeWr.classList.add('is-start-mob-animation');

          setTimeout(function () {
            normalPageInit();
            scrollLock.enablePageScroll();
          }, 1000);
        }
      }
    };

    function normalPageInit() {
      const headerEl = document.querySelector('.header');
      const headerCloseWr = document.querySelector('.header-close-wrapper');
      const mainEL = document.querySelector('.main');
      const siteEL = document.querySelector('#site');
      const bodyBg = document.querySelector('.body-bg');
      const firstBgEL = document.querySelector('.first-sec-bg');

      /!*siteEL.prepend(mainEL);*!/
      if (headerEl) {
        siteEL.prepend(headerCloseWr);
        siteEL.prepend(headerEl);
      }

      if (firstBgEL && bodyBg) {
        bodyBg.prepend(firstBgEL);
      }

      cubeWr.classList.add('is-finish-loader-animation');
      cube.classList.remove('is-worked-loader');

      homeFirsSecTitle?.classList.add('is-title-animated');
      homeFirsSecButtons?.classList.add('is-title-animated');
      setTimeout(function () {
        homeFirsSecButtons?.classList.add('is-title-animated-stop');
      }, 2500);

      initCursor();
      evolveSliderInit();
      beBoldSliderInit();
      initScrollBlurAnimation();
      bgFirstFixedAnimation();
      bgFixedAnimation();
      if (typeof initCaseStudiesHead === 'function') {
        initCaseStudiesHead();
      }
      if (typeof initCaseStudies === 'function') {
        initCaseStudies();
      }
      bgChangeAnimation();
      cardScaleAnimation();
      parallaxVerticalAnimation();

      AOS.refresh();
      setTimeout(() => {
        pauseLatestWorksGradientAnimation();
        pauseProjectGradientAnimation();
      }, 50);
      pauseFooterGradientAnimation();
      btnToTopFunc();
      btnCallFunc();
      checkHeaderOverlapInit();
      textStickyAnimation();
      textParallaxAnimation();
    }

    updateProgress();
    wordsStartAnimation();
    boldLoaderEl.classList.add('is-start-animated');

    setTimeout(() => {
      const firstSecTitle = document.querySelector(
        '.home-first-sec .first-sec__title'
      );
      firstSecTitle.classList.remove('opacity-0');
      firstSecTitle.classList.add('aos-animate');
    }, 2500);
  }
};

boldLoaderNewInit();
*/
